import { ComponentProps } from 'react'

import { Box } from '@mui/material'
import {
  GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium'

export type CustomGridToolbarProps = ComponentProps<typeof GridToolbarContainer> & {
  isColumnsEnabled?: boolean
  isFilterEnabled?: boolean
  isDensityEnabled?: boolean
}

export const CustomGridToolbar: React.FC<CustomGridToolbarProps> = ({ isColumnsEnabled = true, isFilterEnabled = true, isDensityEnabled = true, ...props }) => {
  return (
    <GridToolbarContainer {...props}>
      {isColumnsEnabled && <GridToolbarColumnsButton
        slotProps={{
          button: {
            disableRipple: true,
            disableTouchRipple: true,
          },
        }}
      />}
      {isDensityEnabled && <GridToolbarDensitySelector
        slotProps={{
          button: {
            disableRipple: true,
            disableTouchRipple: true,
          },
        }}
      />}
      {isFilterEnabled && <GridToolbarFilterButton
        slotProps={{
          button: {
            disableRipple: true,
            disableTouchRipple: true,
          },
        }} />}
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarQuickFilter />
    </GridToolbarContainer>
  )
}
